import {BADGES} from 'constants/badges';

export const CTP_BADGES_REDESIGN = {
    LUXURY: BADGES.LUXURY,
    PREMIUM: BADGES.PREMIUM,
    SALE: BADGES.SALE,
} as const;

export const CTP_BADGES_REDESIGN_IDS = [
    CTP_BADGES_REDESIGN.SALE,
    CTP_BADGES_REDESIGN.LUXURY,
    CTP_BADGES_REDESIGN.PREMIUM,
] as const;

export const BADGE_CONTENT = {
    [CTP_BADGES_REDESIGN.LUXURY]: 'Luxury',
    [CTP_BADGES_REDESIGN.PREMIUM]: 'Premium',
    [CTP_BADGES_REDESIGN.SALE]: 'Sale',
};
